import React, { Component } from "react";

import { StyledCurrentHighlights } from "./style";

class CurrentHighlightsFlag extends Component {
  render() {
    return (
      <StyledCurrentHighlights
        isRight={this.props.isRight}
        price={this.props.price}
        subscriptionPrice={this.props.subscriptionPrice}
      >
        £5/8 with Membership
      </StyledCurrentHighlights>
    );
  }
}

export default CurrentHighlightsFlag;
